/**
 * Custom buy box for individual products — see snippets/individual-buybox.liquid.
 *
 * Standalone (no webpack). The card radios are the form's name="quantity" inputs,
 * so <c-subscription> sees quantity changes natively. This script:
 *   - card change      -> hidden .js-default-selling-plan gets the card's 40/80-day plan
 *   - checkbox change  -> stock purchase_type radio + change event
 *   - repaints prices with the Frøya Bundle Discounts quantity tier, mirroring the
 *     discount function (extensions/discount-function-js in Froya-bundle-discounts):
 *     best tier with tier.quantity <= qty for the purchase type, applied to the line
 *     subtotal (Loop plan price for subscriptions) and rounded to a whole unit.
 */
(function () {
  'use strict';

  if (window.__FROYA_INDIVIDUAL_BUYBOX_INIT__) return;
  window.__FROYA_INDIVIDUAL_BUYBOX_INIT__ = true;

  var ROOT = '[data-individual-buybox]';
  var CARD = '[data-qty]';

  // --- Quantity-tier promo (same lookup as findQtyTierPromo in dev/src/js/utils/froya-qty-tier.js)

  function readConfig(host) {
    if (!host) return null;
    if (host.__ibbConfig !== undefined) return host.__ibbConfig;
    var script = host.querySelector('script[data-froya-qty-tier-config]');
    var config = null;
    try {
      config = script && script.textContent.trim() ? JSON.parse(script.textContent) : null;
    } catch (e) {
      config = null;
    }
    host.__ibbConfig = config;
    return config;
  }

  function findPromo(config, variantId, templateName) {
    var bundles = config && Array.isArray(config.bundles) ? config.bundles : [];
    var gid = 'gid://shopify/ProductVariant/' + variantId;
    var siteWide = null;
    for (var i = 0; i < bundles.length; i++) {
      var promo = bundles[i];
      if (!promo || promo.promoType !== 'quantity_tier' || promo.active === false) continue;
      if (!Array.isArray(promo.variantIds) || promo.variantIds.indexOf(gid) === -1) continue;
      var promoTemplate = typeof promo.template === 'string' ? promo.template.trim() : '';
      if (promoTemplate && promoTemplate !== templateName) continue;
      if (promoTemplate) return promo;
      if (!siteWide) siteWide = promo;
    }
    return siteWide;
  }

  function findBestTier(promo, purchaseType, qty) {
    if (!promo || !Array.isArray(promo.tiers)) return null;
    var group = null;
    for (var i = 0; i < promo.tiers.length; i++) {
      if (promo.tiers[i] && promo.tiers[i].purchaseType === purchaseType) {
        group = promo.tiers[i];
        break;
      }
    }
    if (!group || !Array.isArray(group.tiers)) return null;
    var best = null;
    for (var j = 0; j < group.tiers.length; j++) {
      var tier = group.tiers[j];
      if (!tier || tier.quantity > qty) continue;
      if (!best || tier.quantity > best.quantity) best = tier;
    }
    return best;
  }

  function chargedCents(unitCents, qty, tier) {
    var subtotal = unitCents * qty;
    var discount = tier && tier.discount;
    if (!discount || !(discount.value > 0)) return subtotal;
    var major = subtotal / 100;
    var after;
    if (discount.type === 'fixed_amount') {
      var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      after = major - discount.value * rate;
    } else {
      after = major * (1 - discount.value / 100);
    }
    return Math.max(0, Math.round(after)) * 100;
  }

  // --- Rendering

  // snippets/price.liquid rounds to a whole unit; the template is its output for 0.
  function money(box, cents) {
    var template = box.getAttribute('data-money-template') || '$0';
    return template.replace('0', String(Math.round(cents / 100)));
  }

  function setPrice(el, text) {
    if (!el) return;
    var inner = el.querySelector('.product_price');
    if (!inner) {
      inner = document.createElement('span');
      inner.className = 'product_price';
      el.textContent = '';
      el.appendChild(inner);
    }
    if (inner.textContent !== text) inner.textContent = text;
  }

  function show(el, visible) {
    if (el) el.hidden = !visible;
  }

  function quote(box, card, purchaseType, promo) {
    var qty = Number(card.getAttribute('data-qty')) || 1;
    var unit = Number(card.getAttribute(purchaseType === 'subscription' ? 'data-unit-sub' : 'data-unit-otp')) || 0;
    var final = chargedCents(unit, qty, findBestTier(promo, purchaseType, qty));
    var compare = (Number(box.getAttribute('data-base-cents')) || 0) * qty;
    var save = Math.max(0, compare - final);
    return {
      qty: qty,
      final: final,
      compare: compare,
      save: save,
      pct: compare > 0 ? Math.round((save * 100) / compare) : 0
    };
  }

  function paintNumbers(box, host) {
    var config = readConfig(host);
    var promo = config
      ? findPromo(config, box.getAttribute('data-variant-id'), (host && host.getAttribute('data-froya-template')) || '')
      : null;
    var badgeTemplate = box.getAttribute('data-badge-template') || '';
    var saveTemplate = box.getAttribute('data-save-template') || '';
    var maxSubPct = 0;
    var cards = box.querySelectorAll(CARD);

    for (var i = 0; i < cards.length; i++) {
      var states = [['subscription', 'sub'], ['one_time', 'otp']];
      for (var s = 0; s < states.length; s++) {
        var q = quote(box, cards[i], states[s][0], promo);
        // Sold-out cards (see the snippet) don't count towards the checkbox headline.
        if (states[s][0] === 'subscription' && q.pct > maxSubPct && !cards[i].hasAttribute('data-sold-out')) maxSubPct = q.pct;

        var info = cards[i].querySelector('.c-individual-buybox__info[data-state="' + states[s][1] + '"]');
        var prices = cards[i].querySelector('.c-individual-buybox__prices[data-state="' + states[s][1] + '"]');
        var saveEach = Math.round(q.save / q.qty);

        var badge = info && info.querySelector('[data-ibb="badge"]');
        if (badge) badge.textContent = badgeTemplate.replace('__PCT__', q.pct);
        show(badge, q.pct > 0);

        var saveWrap = info && info.querySelector('[data-ibb="save"]');
        var saveText = info && info.querySelector('[data-ibb="save-text"]');
        if (saveText) saveText.textContent = saveTemplate.replace('__AMOUNT__', money(box, saveEach));
        show(saveWrap, Math.round(saveEach / 100) > 0);

        setPrice(prices && prices.querySelector('[data-ibb="price"]'), money(box, q.final / q.qty));
        var compareEl = prices && prices.querySelector('[data-ibb="compare"]');
        setPrice(compareEl && compareEl.querySelector('s'), money(box, q.compare / q.qty));
        show(compareEl, q.save > 0);
      }
    }

    var pctEls = box.querySelectorAll('[data-ibb-max-pct]');
    for (var k = 0; k < pctEls.length; k++) pctEls[k].textContent = String(maxSubPct);
    return promo;
  }

  function paintState(box, parts, promo) {
    // The selected card is styled from its radio's :checked state in CSS.
    var subscribed = parts.checkbox.checked;
    box.classList.toggle('is-otp', !subscribed);

    var card = parts.qty.closest(CARD);
    if (!card || !parts.host) return;
    var total = money(box, quote(box, card, subscribed ? 'subscription' : 'one_time', promo).final);
    var targets = parts.host.querySelectorAll('.js-individual-buybox-atc-price');
    for (var j = 0; j < targets.length; j++) setPrice(targets[j], total);
  }

  // --- Syncing the stock form

  function getParts(box) {
    return {
      form: box.closest('form'),
      host: box.closest('c-subscription'),
      checkbox: box.querySelector('.js-individual-buybox-subscribe'),
      qty: box.querySelector('.js-individual-buybox-qty:checked')
    };
  }

  function syncPlan(parts) {
    var card = parts.qty.closest(CARD);
    var input = parts.form.querySelector('input.js-default-selling-plan');
    if (card && input) input.value = card.getAttribute('data-plan-id');
  }

  function syncPurchaseType(parts) {
    var value = parts.checkbox.checked ? 'subscription' : 'one_time';
    var radio = parts.form.querySelector('input[name="purchase_type"][value="' + value + '"]');
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function update(box, repaintNumbers) {
    var parts = getParts(box);
    if (!parts.form || !parts.checkbox || !parts.qty) return;
    if (repaintNumbers || box.__ibbPromo === undefined) box.__ibbPromo = paintNumbers(box, parts.host);
    syncPlan(parts);
    syncPurchaseType(parts);
    paintState(box, parts, box.__ibbPromo);
  }

  function init(scope) {
    var boxes = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < boxes.length; i++) update(boxes[i], true);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('js-individual-buybox-qty') && !target.classList.contains('js-individual-buybox-subscribe')) return;
    var box = target.closest(ROOT);
    if (box) update(box, false);
  });

  // Theme Editor re-renders the section; restored form state (back/forward cache) is re-read too.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) init();
  });

  init();
})();
